import * as Yup from 'yup';
import { showWarningToast } from '../../../utils/toastHelper';
import i18next from 'i18next';
export const t = (key) => i18next.t(key, { ns: 'Customer' });
// Common Schema Fields
const commonSchema = {
  customer_group: Yup.object()
    .nullable()
    .required('CUSTOMER_GROUP_REQUIRED')
    .shape({ id: Yup.string().required('CUSTOMER_GROUP_REQUIRED') }),
  code: Yup.string().trim().required('CODE_REQUIRED'),
  delivery_address: Yup.string().trim().required('DELIVERY_ADDRESS_REQUIRED'),
  contact_name: Yup.string().trim().required('CONTACT_PERSON_NAME_REQUIRED'),
  contact_phone: Yup.string()
    .trim()
    // .matches(/^[0-9]+$/, 'PHONE_NUMBER_NUMERIC')
    .min(8, 'PHONE_NUMBER_MIN')
    // .max(15, 'PHONE_NUMBER_MAX')
    .required('CONTACT_PHONE_NUMBER_REQUIRED'),
  email: Yup.string()
    .trim()
    .nullable()
    .notRequired()
    .test('is-valid-email', 'INVALID_EMAIL_FORMAT', (value) => {
      if (!value) return true; // Allow empty values
      return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
    }),

  area: Yup.object()
    .nullable()
    .required('AREA_CANNOT_BE_EMPTY')
    .shape({ id: Yup.string().required('AREA_ID_REQUIRED') }),
  district: Yup.object()
    .nullable()
    .required('DISTRICT_CANNOT_BE_EMPTY')
    .shape({ id: Yup.string().required('DISTRICT_ID_REQUIRED') }),
  logistic_line: Yup.object()
    .nullable()
    .required('LOGISTIC_LINE_CANNOT_BE_EMPTY')
    .shape({ id: Yup.string().required('LOGISTIC_LINE_ID_REQUIRED') }),
  payment_method: Yup.object()
    .nullable()
    .required('PAYMENT_METHOD_CANNOT_BE_EMPTY')
    .shape({ id: Yup.string().required('PAYMENT_METHOD_ID_REQUIRED') }),
};

// Define Schemas Dynamically
export const addCateringCustomerSchema = Yup.object().shape({
  ...commonSchema,
  name: Yup.string().trim().required('CUSTOMER_NAME_REQUIRED'),
});

export const addFBZCustomerSchema = Yup.object().shape({
  ...commonSchema,
});

// Common Validation Function
const validateSchema = async (schema, data) => {
  try {
    await schema.validate(data, { abortEarly: false });
    return true;
  } catch (error) {
    // error.inner.forEach((err) => {
    //     showWarningToast(err.message);
    //    });
    if (Array.isArray(error.inner) && error.inner.length > 0) {
      const firstError = error.inner[0];
      if (firstError.message) {
        showWarningToast(t(firstError.message)); // Show the first message
      }
    }
    return false;
  }
};

export const validateCateringCustomer = (data) =>
  validateSchema(addCateringCustomerSchema, data);
export const validateFBZCustomer = (data) =>
  validateSchema(addFBZCustomerSchema, data);
